import { useState, useEffect } from "react";
import axios from "axios";
import { Check, Clock, Trash2, Search, AlertTriangle } from "lucide-react";
import "./Filmes.css";

export default function Filmes() {
    const [movies, setMovies] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("TODOS"); // 'TODOS' | 'QUERO_ASSISTIR' | 'ASSISTIDO'

    // Estado do item a ser excluído pelo modal customizado
    const [movieToDelete, setMovieToDelete] = useState(null);

    const fetchMovies = async () => {
        try {
            const response = await axios.get("http://localhost:5000/api/filmes");
            setMovies(response.data);
        } catch (error) {
            console.error("Erro ao carregar filmes:", error);
        }
    };

    useEffect(() => {
        fetchMovies();
    }, []);

    const handleSearchTMDB = async (e) => {
        e.preventDefault();
        if (!searchQuery.trim()) return;

        setLoading(true);
        try {
            const response = await axios.get("http://localhost:5000/api/filmes/tmdb/search", {
                params: { query: searchQuery },
            });
            setSearchResults(response.data);
        } catch (error) {
            console.error("Erro ao buscar no TMDB:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleAddMovie = async (movie) => {
        try {
            await axios.post("http://localhost:5000/api/filmes", {
                title: movie.title,
                year: movie.year,
                posterUrl: movie.posterUrl,
                rating: movie.rating,
                tmdbId: movie.tmdbId,
                watchStatus: "Quero Assistir",
            });
            setSearchResults([]);
            setSearchQuery("");
            fetchMovies();
        } catch (error) {
            console.error("Erro ao adicionar filme:", error);
        }
    };

    const handleToggleStatus = async (id, currentStatus) => {
        const nextStatus = currentStatus === "Assistido" ? "Quero Assistir" : "Assistido";
        try {
            await axios.patch(`http://localhost:5000/api/filmes/${id}/status`, {
                watchStatus: nextStatus,
            });
            fetchMovies();
        } catch (error) {
            console.error("Erro ao alterar status:", error);
        }
    };

    // Abre o modal de confirmação
    const requestDeleteMovie = (movie) => {
        setMovieToDelete(movie);
    };

    // Confirma a exclusão definitiva
    const confirmDeleteMovie = async () => {
        if (!movieToDelete) return;
        try {
            await axios.delete(`http://localhost:5000/api/filmes/${movieToDelete.id}`);
            setMovies((prev) => prev.filter((m) => m.id !== movieToDelete.id));
        } catch (error) {
            console.error("Erro ao excluir filme:", error);
        } finally {
            setMovieToDelete(null);
        }
    };

    const countQueroAssistir = movies.filter((m) => m.watchStatus === "Quero Assistir").length;
    const countAssistidos = movies.filter((m) => m.watchStatus === "Assistido").length;

    const filteredMovies = movies.filter((movie) => {
        if (activeTab === "QUERO_ASSISTIR") return movie.watchStatus === "Quero Assistir";
        if (activeTab === "ASSISTIDO") return movie.watchStatus === "Assistido";
        return true;
    });

    return (
        <div className="movies-page">
            <header className="movies-header">
                <h1>Catálogo de Filmes</h1>
                <form onSubmit={handleSearchTMDB} className="search-bar-container">
                    <input
                        type="text"
                        placeholder="Pesquisar filme no TMDB..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="search-input"
                    />
                    <button type="submit" disabled={loading} className="search-button">
                        <Search size={18} />
                        <span>{loading ? "Buscando..." : "Buscar"}</span>
                    </button>
                </form>
            </header>

            {/* Resultados TMDB */}
            {searchResults.length > 0 && (
                <section className="search-results-section">
                    <h2>Resultados da Pesquisa</h2>
                    <div className="search-results-track">
                        {searchResults.map((item) => (
                            <div key={item.tmdbId} className="search-card">
                                {item.posterUrl ? (
                                    <img src={item.posterUrl} alt={item.title} className="card-poster" />
                                ) : (
                                    <div className="card-poster-placeholder">Sem Imagem</div>
                                )}
                                <p className="card-title" title={item.title}>{item.title}</p>
                                <span className="card-year">{item.year || "N/A"}</span>
                                <button onClick={() => handleAddMovie(item)} className="btn-add">
                                    Adicionar
                                </button>
                            </div>
                        ))}
                    </div>
                </section>
            )}

            {/* Navegação por Abas */}
            <div className="movies-tabs">
                <button
                    className={`tab-button ${activeTab === "TODOS" ? "active" : ""}`}
                    onClick={() => setActiveTab("TODOS")}
                >
                    Todos ({movies.length})
                </button>
                <button
                    className={`tab-button ${activeTab === "QUERO_ASSISTIR" ? "active" : ""}`}
                    onClick={() => setActiveTab("QUERO_ASSISTIR")}
                >
                    Quero Assistir ({countQueroAssistir})
                </button>
                <button
                    className={`tab-button ${activeTab === "ASSISTIDO" ? "active" : ""}`}
                    onClick={() => setActiveTab("ASSISTIDO")}
                >
                    Assistidos ({countAssistidos})
                </button>
            </div>

            {/* Grid de Filmes Salvos */}
            <div className="movies-grid">
                {filteredMovies.map((movie) => {
                    const isWatched = movie.watchStatus === "Assistido";
                    return (
                        <div key={movie.id} className="movie-card">
                            <div className="poster-wrapper">
                                {movie.posterUrl ? (
                                    <img src={movie.posterUrl} alt={movie.title} className="card-poster" />
                                ) : (
                                    <div className="card-poster-placeholder">Sem Imagem</div>
                                )}
                                <span className={`status-badge ${isWatched ? "assistido" : "quero-assistir"}`}>
                                    {isWatched ? <Check size={12} /> : <Clock size={12} />}
                                    {movie.watchStatus}
                                </span>
                            </div>

                            <div className="card-body">
                                <h3 className="card-title" title={movie.title}>{movie.title}</h3>
                                <span className="card-year">{movie.year || "Ano desconhecido"}</span>
                            </div>

                            <div className="card-actions">
                                <button
                                    onClick={() => handleToggleStatus(movie.id, movie.watchStatus)}
                                    className={`btn-toggle ${isWatched ? "to-unwatch" : "to-watch"}`}
                                    title={isWatched ? "Mudar para Quero Assistir" : "Marcar como Assistido"}
                                >
                                    {isWatched ? "Quero Assistir" : "Assistido"}
                                </button>

                                <button
                                    onClick={() => requestDeleteMovie(movie)}
                                    className="btn-delete"
                                    title="Remover da lista"
                                >
                                    <Trash2 size={16} />
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* --- MODAL DE CONFIRMAÇÃO DE EXCLUSÃO --- */}
            {movieToDelete && (
                <div className="movies-confirm-overlay" onClick={() => setMovieToDelete(null)}>
                    <div className="movies-modal-box" onClick={(e) => e.stopPropagation()}>
                        <div className="movies-modal-icon">
                            <AlertTriangle size={44} />
                        </div>
                        <h3>Remover Filme?</h3>
                        <p>
                            Deseja remover <strong>"{movieToDelete.title}"</strong> da sua lista?
                        </p>
                        <div className="movies-modal-actions">
                            <button
                                className="movies-btn-cancel"
                                onClick={() => setMovieToDelete(null)}
                            >
                                Cancelar
                            </button>
                            <button className="movies-btn-confirm" onClick={confirmDeleteMovie}>
                                Sim, Remover
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}